module.exports = __webpack_public_path__ + "img/gifty-scan.b978b860.webp";